<template>
    <table>
        <tbody>
            <tr>
                <td>
                    <input type="checkbox" :id="policy.plcyId" class="checkbox txt-none" :value="policy.plcyId" v-model="isCheckAll" @click="onChecked()">
                    <label :for="policy.plcyId"></label>
                    <span class="rule-title" @click="showDetail()">
                        <span :data-type="policy.userDefiYn == 'N'? 'policy-system' : 'policy-custom'" class="icon-tag">{{policy.userDefiYn == 'N'? 'Best Practice' : 'User Settings'}}</span>
                        <span v-for="(vendor, index) of JSON.parse(policy.vendorsjs)" :key="index" :data-vendor="getVendor(vendor)" data-size="m" class="icon-vender txt-none"></span>
                        <span style="display: block;">{{policy.transTitl}}</span>
                    </span>
                </td>
                <td class="description" @click="showDetail()">
                    <div>
                        <div class="rule-description">
                            {{policy.transDesc}}
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="rule-detail" v-if="isShowDetail">
                <td colspan="2">
                    <div-loading v-if="isLoading"></div-loading>
                    <div v-else>
                        <table v-if="govRuleList.length == 0" style="width:100%">
                            <tbody>
                                <tr>
                                    <td>
                                        <span>{{$t('COMMON.NO_DATA')}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table v-else style="width:100%">
                            <tbody>
                                <tr v-for="(rule) of govRuleList" :key="rule.ruleId">
                                    <td>
                                        <input type="checkbox" :id="id + rule.ruleId" :value="rule.ruleId" v-model="listRuleValue" class="checkbox txt-none" @click="onCheckedRule(rule.ruleId)">
								        <label :for="id + rule.ruleId"></label>
                                        <span>{{rule.transTitl}}</span>
                                        <span class="rule-name-category">
                                            <span indexrule="0">
                                                <span data-type="category-label" class="icon-tag" v-for="(ctg, idx) of rule.ctgLabel" :key="idx">{{getCategoryLabel(ctg)}}</span>
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
	name: "PolicyItem",
	data() {
		return {
			isShowDetail: false,
			isLoading: false,
			govRuleList: [],
            listRuleValue: [],
            categoryList: [],
            isCheckAll: false
		}
	},
	props: {
        policy: {
			type: Object,
			default: {}
		},
		listSelectedPolicy: {
			type: Array,
			default: () => []
		},
        listSelectedRule: {
			type: Array,
			default: () => []
		},
        currentCmpnId: {
			type: String,
			default: ""
		},
        id: {
			type: String,
			default: "import-rule"
		},
	},
    computed: {
        getLocale: function () {
            return this.$i18n.locale
        }
    },
    created() {
        this.setIsCheckAll();
    },
    watch: {
        listSelectedPolicy(newVal, oldVal) {
            this.setIsCheckAll();
        }
    },
	methods: {
		getVendor(vendor) {
			vendor = (vendor || "").toLowerCase();
			if (vendor == 'azu') {
				vendor = 'azure';
			}
			return vendor;
		},
        onChecked() {
			this.$emit('onChecked', this.policy);
            if (this.isCheckAll) {
                this.listRuleValue = [];
            } else {
                this.listRuleValue = this.govRuleList.map(e => e.ruleId);
            }
		},
        getCheckAllRule() {
            if (this.isCheckAll) {
                this.listRuleValue = this.govRuleList.map(e => e.ruleId);
            }
        },
		showDetail() {
			this.isShowDetail = !this.isShowDetail;
            if (this.isShowDetail) {
                this.isLoading = true;

                let getRuleList = this.getRuleList();
                let getCategoryList = this.getCategoryList();
                let _this = this;
                Promise.all([getRuleList, getCategoryList]).then((result) => {
                    if (result[0] && result[0].data.status === 'ok') {
                        // for 에서 text 를 json 으로 parse
                        for (let rule of result[0].data.result) {
                            rule.transTitl = rule.userDefiYn === _this.constants.PARAM.SELECT.N ? rule[_this.getLocale + 'RuleTitle'] : rule.titl;
                            rule.transDesc = rule.userDefiYn === _this.constants.PARAM.SELECT.N ? rule[_this.getLocale + 'RuleDesc'] : rule.desc;
                            rule.transRemd = rule.userDefiYn === _this.constants.PARAM.SELECT.N ? rule[_this.getLocale + 'RuleRemd'] : rule.remd;
                            rule.cndVal = _this.Common.parseJSON(rule.cndVal);
                            rule.actnVal = _this.Common.parseJSON(rule.actnVal);
                            rule.ctgLabel = _this.Common.parseJSON(rule.ctgLabel);
                            rule.rulePlcyRvsnId = _this.policy.rvsnId;
                        }
                        _this.govRuleList = result[0].data.result;
                        _this.setIsCheckAll();
                        _this.getCheckAllRule();
                        _this.setSelectedRule();
                    }
                    _this.categoryList = result[1].data.result;
                    _this.isLoading = false;
                });       
            }
		},
		getRuleList() {
            const url = '/api/governance/rule/list';
            const ruleData = {
                cmpnId: this.currentCmpnId,
                rvsnId: this.policy.rvsnId
            }
            return this.http.post(url, ruleData);
            
        },
        getCategoryList() {
            var url = `/api/governance/category/list/simple`;
            var body = {
                "cmpnId": this.currentCmpnId
            };

            return this.http.post(url, body);
        },
        getCategoryLabel(ctgId) {
            var categoryLabel = ''
            for (var category of this.categoryList) {
                if (category.ctgId === ctgId) {
                    categoryLabel = category.ctgLabel
                }
            }
            return categoryLabel
        },
        onCheckedRule(ruleId) {
            let index = this.listRuleValue.indexOf(ruleId);
            if (index !== -1) {
                this.listRuleValue.splice(index, 1);
            } else {
                this.listRuleValue.push(ruleId);
            }
            let rules = this.govRuleList.filter(e => _.findIndex(this.listRuleValue, function(o) { return o == e.ruleId}) != -1)

            let listPolicyId = this.listSelectedPolicy.map(policy => policy.plcyId);
            let idx = listPolicyId.indexOf(this.policy.plcyId);
            if (idx === -1) {
                if (this.listRuleValue.length == this.govRuleList.length) {
                    this.isCheckAll = true;
                    this.$emit('onChecked', this.policy);
                    this.$emit('onCheckedRule', {
                        isCheckAll: true,
                        plcyId: this.policy.plcyId,
                        ruleIds: this.listRuleValue,
                        rules: rules
                    });
                } else {
                    this.isCheckAll = false;
                    this.$emit('onCheckedRule', {
                        isCheckAll: false,
                        plcyId: this.policy.plcyId,
                        ruleIds: this.listRuleValue,
                        rules: rules
                    });
                }
            } else {
                if (this.listRuleValue.length !== this.govRuleList.length) {
                    this.isCheckAll = false;
                    this.$emit('onChecked', this.policy);
                    if (this.listRuleValue.length === 0) {
                        this.$emit('onCheckedRule', {
                            isCheckAll: true,
                            plcyId: this.policy.plcyId,
                            ruleIds: this.listRuleValue,
                            rules: rules
                        });
                    } else {
                        this.$emit('onCheckedRule', {
                            isCheckAll: false,
                            plcyId: this.policy.plcyId,
                            ruleIds: this.listRuleValue,
                            rules: rules
                        });
                    }
                    
                }
            }
        },
        setIsCheckAll() {
            let listPolicyId = this.listSelectedPolicy.map(policy => policy.plcyId);
            if (listPolicyId.indexOf(this.policy.plcyId) === -1) {
                this.isCheckAll = false; 
            } else {
                this.isCheckAll = true;
            }
        },
        setSelectedRule() {
            if (!this.isCheckAll) {
                let policy = (this.listSelectedRule.filter(rule => rule.plcyId == this.policy.plcyId)[0] || []);
                let selectedRule = [];
                (policy.ruleIds || []).forEach(ruleId => {
                    selectedRule.push(ruleId);
                });
                this.listRuleValue = selectedRule;
            }
        }
	}
}
</script>

<style scoped>
.custom-pagination.-pagination {
	position: inherit;
}
span.rule-title {
	display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: calc(100% - 20px);
	width: 500px;
}
.rule-description {
	display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
	width: 550px;
}
.description {
	border-left: none;
}
.float-left {
	float: left;
}
.vertical-align-baseline {
	vertical-align: baseline !important;
}
.table-rule {
	height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/policy/policyComponents/PolicyItem.vue